import React, { useRef, useState } from 'react';
import { Form, Button, Card, Alert, Modal, Container } from "react-bootstrap";
import { useAuth } from "../../contexts/AuthContext";
import { Link, useHistory } from "react-router-dom";
import logo from "../../logo-transparente.png"

export default function ForgotPassword() {
    const emailRef = useRef();
    const { resetPassword } = useAuth();
    const [error, setError] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    async function handleSubmit(e) {
        e.preventDefault();

        try {
            setError('');
            setLoading(true);
            await resetPassword(emailRef.current.value);
            setShowAlert(true);
        } catch (error) {
            if (error.code === "auth/invalid-email" || e.code === "auth/user-not-found") {
                setError("Error al recuperar contraseña: " + 
                    "No existe un usuario con el e-mail ingresado");
            } else {
                setError("Error inesperado al recuperar contraseña")
            }
        }

        setLoading(false);
    }

    function handleClose() {
        setShowAlert(false);
        history.push("/login");
    }

    return (
        <Container 
        className="d-flex align-items-center justify-content-center"
        style = {{ minHeight: "100vh" }}
        >
            <div className="w-100" style = {{ maxWidth: "400px"}}>
                <img className="mx-auto d-block" src={logo} alt="Inventario Provell" style={{ maxHeight: "95px" }}/>
                <br/>
                <Modal show={showAlert} onHide={handleClose}>
                    <Modal.Header>
                        <Modal.Title>Correo de recuperación enviado</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Se ha enviado un correo al e-mail ingresado con un 
                        enlace para recuperar su contraseña. 
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleClose}>
                            Regresar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Card>
                    <Card.Body>
                        <h2 className="text-center mb-4">Reiniciar Contraseña</h2>
                        {error && <Alert variant="danger">{error}</Alert>}
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3" controlId="formGridEmail">
                                <Form.Label>E-mail</Form.Label>
                                <Form.Control type="email" ref={emailRef} required/>
                                <Form.Text className="text-muted">
                                    Se enviará un correo para recuperar su contraseña.
                                </Form.Text>
                            </Form.Group>
                            <Button disabled={loading} className="w-100" type="submit">Confirmar</Button>
                        </Form>
                        <div className="w-100 text-center mt-3">
                            <Link to="/login">Iniciar sesión</Link>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </Container>
    )
}